import React, {
  forwardRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '../../store/organizationSettingsStore';

export interface Organization {
  orgId: string;
  orgName: string;
}

interface OrganizationDropdownListProps {
  isOpen: boolean;
  setIsOpen: (_open: boolean) => void;
  organizations: { data: { data: Organization[] } } | undefined;
  switchOrganization: (_orgId: string) => void;
}

const OrganizationDropdownList = forwardRef<HTMLDivElement, OrganizationDropdownListProps>((props, ref) => {
  const { t } = useTranslation();
  const setSelectedOrganization = useOrganizationStore((state) => state.setSelectedOrganization);

  const handleSelect = (organization: Organization) => {
    props.switchOrganization(organization.orgId);
    props.setIsOpen(false);
    setSelectedOrganization(organization);
  };

  if (!props.isOpen) {
    return null;
  }

  return (
    <div className="left-50 fixed bottom-0 z-50 mb-4 w-[320px] rounded-md border bg-white" ref={ref}>
      <div className="w-full py-1">
        <div className="border-b-gray-300 flex h-[42px] items-center border-b px-4 text-sm font-medium text-primary">
          {t('organizationNameAndId')}
        </div>
        {props.organizations?.data?.data.map((org, index) => (
          <button
            key={org.orgId}
            onClick={() => handleSelect(org)}
            className={`flex h-[42px] w-full items-center gap-2 px-4 text-left text-sm ${index % 2 === 0 ? 'bg-[#FAFAFA]' : 'bg-white'}`}
          >
            <div>{org.orgName}</div>
            <div className="font-light">
              #
              {org.orgId}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
});

export default OrganizationDropdownList;
